
export function getAcademicYear(date = new Date()) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;

    if (month < 6) {
        return `${year - 1}-${year}`;
    } else {
        return `${year}-${year + 1}`;
    }
}
